import _ from 'lodash';
import objectAssign from 'object-assign';
import * as types from '../constants/actionTypes';
import 'whatwg-fetch';
import * as utils from './actionUtils';
import toastr from 'toastr';
// import { push } from 'react-router-redux';

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}

export function loadRegDetails(eventId, clubId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('registrations/event/'+ eventId +'/club/' + clubId,
      (result) => {dispatch(loadRegDetailsSuccess(result));},
      (error) => {dispatch(loadRegDetailsFail(error));},
      defaultDelay);
    dispatch({
      type: types.LOAD_REG_DETAILS,
    });
  };
}

export function loadRegReviewDetails(eventId, clubId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('registrations/event/'+ eventId +
                  '/club/' + clubId +
                  '/last_approved',
      (result) => {dispatch(loadRegReviewDetailsSuccess(result));},
      (error) => {dispatch(loadRegDetailsFail(error));},
      defaultDelay);
    dispatch({
      type: types.LOAD_REG_REVIEW_DETAILS,
    });
  };
}

export function loadRegDetailsSuccess(details) {
  return {
    type: types.LOAD_REG_DETAILS_SUCCESS,
    details: details,
    detailsUpdated: Date.now(),
  };
}

export function loadRegReviewDetailsSuccess(details) {
  return {
    type: types.LOAD_REG_REVIEW_DETAILS_SUCCESS,
    details: details,
    detailsUpdated: Date.now(),
  };
}

export function approveRegChanges(clubReg, data) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('registrations/'+ clubReg.id +
                  '/approve',
      'PUT',
      data,
      (result) => {
        dispatch(loadRegReviewDetailsSuccess({}));
        dispatch(loadRegDetails(clubReg.event, clubReg.club));
      },
      (error) => {dispatch(loadRegDetailsFail(error));},
      defaultDelay);
  };
}

export function loadRegDetailsFail(errors) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_REG_DETAILS_FAILURE,
      errors: errors,
      detailsUpdated: Date.now(),
    });
  };
}

export function update(details) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    dispatch({
      type: types.SAVE_REG,
    });
    utils.sendData('registrations/'+ details.id, 'PUT', details,
      (result) => {dispatch(updateSuccess(result));},
      (errors) => {dispatch(updateFail(errors));},
      defaultDelay);
  };
}

export function create(details) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    dispatch({
      type: types.SAVE_REG,
    });
    utils.sendData('registrations/', 'POST', details,
      (result) => {dispatch(createSuccess(result));},
      (errors) => {dispatch(updateFail(errors));},
      defaultDelay);
  };
}

export function updateSuccess(details) {
  return function(dispatch) {
    toastr.success('Lagret');
    dispatch({
      type: types.UPDATE_REG_SUCCESS,
      details: details,
      detailsUpdated: Date.now(),
    });
  };
}

export function createSuccess(details) {
  return function(dispatch) {
    toastr.success('Lagret');
    dispatch({
      type: types.CREATE_REG_SUCCESS,
      details: details,
      detailsUpdated: Date.now(),
    });
  };
}

export function updateFail(errors) {
  return function(dispatch) {
    if (errors.danger) {
      toastr.error(errors.details, 'Lagring feilet');
    } else {
      toastr.warning(errors.details, 'Lagring feilet');
    }
    dispatch({
      type: types.UPDATE_REG_FAILURE,
      errors: errors,
    });
  };
}

export function loadTeamList(eventId, clubId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    let url = 'registrations/event/'+ eventId +'/club/' + clubId + '/teams';
    utils.getData(url,
      (result) => {dispatch(loadTeamListSuccess(result));},
      (error) => {dispatch(loadTeamListFail(error));},
      defaultDelay);
    dispatch({
      type: types.LOAD_TEAM_LIST,
    });
  };
}

export function loadTeamListSuccess(list) {
  return {
    type: types.LOAD_TEAM_LIST_SUCCESS,
    teamList: list,
    teamListUpdated: Date.now(),
  };
}


export function loadTeamListFail(errors) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_TEAM_LIST_FAILURE,
      teamErrors: errors,
      teamDetailsUpdated: Date.now(),
    });
  };
}

export function updateTeam(details) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('registrations/teams/'+ details.id, 'PUT', details,
      (result) => {dispatch(saveTeamSuccess(result));},
      (errors) => {dispatch(saveTeamFail(errors));},
      defaultDelay);
  };
}

export function createTeam(details) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('registrations/teams/', 'POST', details,
      (result) => {dispatch(saveTeamSuccess(result));},
      (errors) => {dispatch(saveTeamFail(errors));},
      defaultDelay);
  };
}

export function saveTeamSuccess(details) {
  return function(dispatch, getState) {
    let teamList = objectAssign([], getState().registration.teamList);
    let index = _.indexOf(teamList, _.find(teamList, {identifier: details.identifier}));
    if (index == -1) {
      teamList.push(details);
    } else {
      teamList.splice(index, 1, details);
    }
    toastr.success('Lagret');
    dispatch({
      type: types.SAVE_TEAM_SUCCESS,
      teamList: teamList,
      detailsUpdated: Date.now(),
    });
  };
}

export function saveTeamFail(errors) {
  return function(dispatch) {
    toastr.warning(errors, 'Lagring feilet');
    dispatch({
      type: types.SAVE_TEAM_FAILURE,
      errors: errors,
    });
  };
}

export function deleteTeam(details) {
  return function (dispatch, getState) {
    let teamList = getState().registration.teamList;
    if (details.id != undefined) {
      dispatch(utils.beginAjaxCall());
      utils.deleteData('registrations/teams/' + details.id, () => {
        toastr.success('Slettet');
      }, defaultDelay);
    }
    teamList = _.reject(teamList, {identifier: details.identifier});
    dispatch(loadTeamListSuccess(teamList));
  };
}

export function loadApprovedRegList(eventId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('registrations/event/'+ eventId,
      (result) => {dispatch(loadApprovedRegListSuccess(result));},
      (error) => {dispatch(loadApprovedRegListFail(error));},
      defaultDelay);
  };
}

export function loadApprovedRegListSuccess(list) {
  return {
    type: types.LOAD_APPROVED_REG_LIST_SUCCESS,
    approvedRegList: list,
    approvedRegListUpdated: Date.now(),
  };
}

export function loadApprovedRegListFail() {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_APPROVED_REG_LIST_FAILURE,
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/regActions.js
 **/